import { useRepositoryMutation } from '@mews-commander/data-access';
import { openFileInNewTab } from '@mews-commander/utils';

export const useOpenContractInNewTab = () => {
    return useRepositoryMutation('reservationContracts', 'download', {
        onSuccess: async ({ type, data }) => openFileInNewTab({ contentType: type, fileContentsAsBase64String: data }),
    });
};
